import { render, staticRenderFns } from "./LoteProducaoConsumoRacaoGrafico.vue?vue&type=template&id=2f98a968&"
import script from "./LoteProducaoConsumoRacaoGrafico.vue?vue&type=script&lang=js&"
export * from "./LoteProducaoConsumoRacaoGrafico.vue?vue&type=script&lang=js&"
import style0 from "./LoteProducaoConsumoRacaoGrafico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VFlex,VLayout,VToolbarTitle})
